<div class="flex justify-center items-center w-full py-4 z-50">
    <div class="w-4/5 max-w-[600px]">
        <div
            class="h-4 rounded-md overflow-hidden"
            role="progressbar"
            [attr.aria-valuemax]="100"
            [attr.aria-valuemin]="0"
            [attr.aria-valuenow]="progress()"
            [class.bg-[var(--error-background)]]="hasError()"
            [class.bg-[var(--secondary-container)]]="!hasError()">
            <div
                class="h-full transition-all duration-300 ease-in-out"
                [class.bg-[var(--error)]]="hasError()"
                [class.bg-[var(--secondary)]]="!hasError()"
                [style.width.%]="progress()"></div>
        </div>

        <div class="flex justify-between mt-2 text-sm text-[var(--primary)]">
            <span>{{ itemsLoaded() }} {{ 'loadedItems' | transloco }}</span>
            <span class="text-end">{{ total() }} {{ 'totalItems' | transloco }}</span>
        </div>
    </div>
</div>
